
export enum PremiumTypes {
    ANNUAL = "ANNUAL",
    GROUP = "GROUP",
    DAILY_RANGE = "DAILY_RANGE"
   
}
